import { render } from "./SendAdminRequest.vue?vue&type=template&id=cecfaf7a&scoped=true"
import script from "./SendAdminRequest.vue?vue&type=script&lang=js"
export * from "./SendAdminRequest.vue?vue&type=script&lang=js"

import "./SendAdminRequest.vue?vue&type=style&index=0&id=cecfaf7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cecfaf7a"]])

export default __exports__